import { FC } from 'react';
import Select, { SelectProps } from 'components/Select';

type Props = SelectProps;

const options = [
  { value: 'KIWI', label: 'Kiwi' },
  { value: 'WAAVO', label: 'Waavo' },
];

const FlightsProviderSelect: FC<Props> = props => (
  <Select fullWidth options={options} {...props} />
);

export default FlightsProviderSelect;
